
const digest = 'c30a0ef9290827bc5941113871c05583431c10ae0883db60ca61c583bbb9a006';
const classes = {"wrapper":"_wrapper_c4kui_1","header":"_header_c4kui_12","title":"_title_c4kui_17","archived":"_archived_c4kui_24","dateOfDeath":"_dateOfDeath_c4kui_27","cross":"_cross_c4kui_35","content":"_content_c4kui_38"};
const css = `._wrapper_c4kui_1 {
  font-family: "Rubik", sans-serif;
  display: flex;
  flex-direction: column;
  padding: 12px;
  gap: 4px;
}
._wrapper_c4kui_1:hover {
  background-color: rgb(217, 232, 254);
  cursor: pointer;
}
._wrapper_c4kui_1 ._header_c4kui_12 {
  display: flex;
  align-items: center;
  gap: 10px;
}
._wrapper_c4kui_1 ._header_c4kui_12 ._title_c4kui_17 {
  font-weight: 500;
  color: #1665d8;
  text-decoration: underline;
  font-size: 14px;
  display: flex;
}
._wrapper_c4kui_1 ._header_c4kui_12 ._title_c4kui_17._archived_c4kui_24 {
  color: #505050;
}
._wrapper_c4kui_1 ._header_c4kui_12 ._dateOfDeath_c4kui_27 {
  display: flex;
  flex-direction: row;
  gap: 5px;
  font-size: 12px;
  color: #000000;
  text-decoration: none;
}
._wrapper_c4kui_1 ._header_c4kui_12 ._dateOfDeath_c4kui_27 ._cross_c4kui_35 {
  height: 12px;
}
._wrapper_c4kui_1 ._content_c4kui_38 {
  display: flex;
  flex-direction: row;
  column-gap: 10px;
  flex-wrap: wrap;
  color: #000000;
  font-weight: 400;
  font-size: 12px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  